import Vue from 'vue';
import App from './App.vue';

import "./assets/js/rem";
import commin from "./assets/js/commin";
import rsa from "./assets/js/rsa";
import store from "./assets/js/store"
import allApi from "./assets/js/api";
import {router} from "./assets/js/router";




import 'swiper/dist/css/swiper.css';
import "./assets/result.css";
import animate from "animate.css"


Vue.use(animate);


Vue.prototype.commin = commin;
Vue.prototype.$rsa = rsa;
Vue.prototype.allApi = allApi;
// Vue.prototype.ip = "http://qiniustorage.yuntuys.com";

let Bus = new Vue()
Vue.prototype.Bus = Bus

Vue.config.productionTip = true;

// 截取字符串加省略号
Vue.filter('valLength', function(val, maxLen){
  // console.log(val);
  if( !val ) return val;
  val = val.replace(/<[^>]+>/g,"");
  if( val.length > maxLen ) {
    val = val.slice(0, maxLen) + "...";
    return val;
  }else{
    return val;
  }
});
// 播放次数/收藏人数超过10000转换成1万
Vue.filter('playNum', function(val){
  // console.log(val);
  if( !val ) return val;
  if( val > 10000 ) {
    val = Math.floor(val/10000 * 100) / 100 + "万";
    return val;
  }else{
    return val;
  }
});

new Vue({
  data() {
    return {
      
    }
  },
  computed: {
    // getRoutePath() {
    //   return this.$route.path;
    // },
  },
  created() {
    // var that = this;
    // console.log(that)
    // that.$store.commit("setToken");
  },
  watch: {
    getRoutePath(newV){
      var that = this;
      if( newV != "/audio" ) {
          that.$store.commit('setIsMiniAudioT');
      }
    },
  },
  render: h => h(App),
  router,
  store
}).$mount('#app')